import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { IAgentClaims, IAgentDetail, IUserCustomAttribute } from '@app/models';
import { Table, TableBody, TableHead, TableRow, TableCell, MenuItem, FormControl } from '@material-ui/core';
import { PasslyButton, PasslySelect } from '@app/components';
import { defaultUserClaimsMapping } from '@app/helpers';
import { renderReadOnlyRows } from './openIDConnectConfigEdit.component';
import { useSelector } from 'react-redux';

interface IProps {
    editUserCallback: Function;
    agentClaims?: IAgentClaims;
    agents: any[];
    selectedAgentValue: string;
    setSelectedAgentValue: Function;
    userId: string;
}

const CustomClaimsConfig: React.SFC<IProps> = ({ editUserCallback, agentClaims, agents, selectedAgentValue, setSelectedAgentValue, userId }) => {
    const { translation } = useTypedTranslation();
    const currentUserId = useSelector((state: any) => state.signIn.currentUser.userUuid as string);

    const config = agentClaims && agentClaims.Configuration ? JSON.parse(agentClaims.Configuration) : null;
    const customClaimsMapping: IUserCustomAttribute = !config ? {} : config;
    const onFormChange = (e: any) => {
        const { value } = e.target;

        setSelectedAgentValue(value);
    };
    return (
        <div className='detailPage__section'>
            <div className='detailPage__section-head'>{translation('OIDC_CONFIGURATION_TAB')}</div>
            <div className='detailPage__section-content'>
                <div className='detailPage__claims-section-header'>
                    <FormControl>
                        <PasslySelect
                            name='ChooseAgent'
                            value={selectedAgentValue}
                            onChange={onFormChange}
                            id='chooseAgent-input'
                            label={'OIDC_CLAIM_CHOOSE_AGENT'}
                            options={agents}
                            optionLabel='AgentName'
                            optionValue='ClientId'
                            required
                        />
                    </FormControl>
                    {currentUserId === userId && (
                        <PasslyButton className='detailPage__edit-button' id='editUserLink' onClick={editUserCallback}>
                            {translation('EDIT')}
                        </PasslyButton>
                    )}
                </div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{translation('OIDC_CLAIM_VALUE')}</TableCell>
                            <TableCell></TableCell>
                            <TableCell>{translation('OIDC_CLAIM_NAME')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <>{Object.keys(defaultUserClaimsMapping).map((name) => renderReadOnlyRows(defaultUserClaimsMapping[name], name))}</>
                        <>
                            {Object.keys(customClaimsMapping).length > 0 &&
                                Object.keys(customClaimsMapping).map((name) => renderReadOnlyRows(customClaimsMapping[name], name))}
                        </>
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default CustomClaimsConfig;
